import * as i0 from '@angular/core';
import { EventEmitter, Injectable, Inject, NgModule } from '@angular/core';
import * as i3 from '@upr-web-primer/dynamic-component';
import * as i2 from '@upr-web-primer/locale';
import * as i1 from '@upr-web-primer/tcm-service';
import { find } from 'lodash-es';

class LayoutService {
    constructor(tridion, localeService, dynamicComponentService, layoutPath) {
        this.tridion = tridion;
        this.localeService = localeService;
        this.dynamicComponentService = dynamicComponentService;
        this.layoutPath = layoutPath;
        this.data = [];
        this.setTicketWidgetClass = new EventEmitter(true);
        const locale = this.localeService.getFromStorage();
        this.language = locale.language;
        this.country = locale.country;
        this.buildBaseUrl();
    }
    buildBaseUrl() {
        if (this.tridion.tridionEnvConfig.dynamic_path_enabled) {
            this.tridion.siteConfig$.subscribe((siteConfig) => {
                if (siteConfig) {
                    this.baseUrl = `/${siteConfig.tridion_pub}/${this.language}/${this.country}/views/layout/`;
                }
            });
        }
        else {
            this.baseUrl = this.layoutPath
                .replace('%language%', this.language)
                .replace('%country%', this.country);
        }
    }
    async get(name) {
        const slug = `${name}-${this.language}`;
        if (this.data[slug]) {
            return this.data[slug];
        }
        return await this.request(name);
    }
    request(name) {
        return this.tridion
            .request(`${this.baseUrl + name}`)
            .then((res) => {
            const slug = `${name}-${this.language}`;
            this.data[slug] = res;
            return this.data[slug];
        })
            .catch((error) => {
            console.error(`Failed to retrieve ${this.baseUrl + name}`);
            throw error;
        });
    }
    buildGroupComponent(componentPresentations, groupComponents) {
        const builtComponents = componentPresentations.filter((cp) => find(groupComponents, (_value, key) => key ===
            this.dynamicComponentService.getComponentName(cp.ComponentTemplate.Title)));
        if (builtComponents.length > 0) {
            return builtComponents;
        }
        else {
            return undefined;
        }
    }
}
LayoutService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: LayoutService, deps: [{ token: i1.TcmService }, { token: i2.LocaleService }, { token: i3.DynamicComponentService }, { token: 'LayoutPath' }], target: i0.ɵɵFactoryTarget.Injectable });
LayoutService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: LayoutService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: LayoutService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.TcmService }, { type: i2.LocaleService }, { type: i3.DynamicComponentService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['LayoutPath']
                }] }]; } });

class LayoutServiceModule {
}
LayoutServiceModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: LayoutServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
LayoutServiceModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: LayoutServiceModule });
LayoutServiceModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: LayoutServiceModule, providers: [LayoutService], imports: [[]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: LayoutServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [],
                    exports: [],
                    providers: [LayoutService]
                }]
        }] });

export { LayoutService, LayoutServiceModule };
